export * from '../src/composites/wui-logo-select/index.js';
//# sourceMappingURL=wui-logo-select.js.map